export const BASE_URL = 'https://tradeinsamsungapi.tmx.hu/';
export const CRM_URL = 'https://mobilfutarapi.tmx.hu/';
export const CAMPAIGN_IS_ACTIVE = 0;
export const Z_IS_ACTIVE = 1;
